import { render, staticRenderFns } from "./ModerateTask.vue?vue&type=template&id=048cbd0e&"
import script from "./ModerateTask.vue?vue&type=script&lang=js&"
export * from "./ModerateTask.vue?vue&type=script&lang=js&"
import style0 from "./ModerateTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports